export default "__VITE_PUBLIC_ASSET__30adade0__"